import React from 'react';

import Table from './Table.jsx';

const Tables = (props) => {
        let tableResult = undefined;
        let data = props.data;
        let categories = undefined;

        if (data) {
            categories = data.categorias || [];

            let categoryIds = categories.map((m) => {
                return m.CategoriaId + '-' + m.ProductoId
            });

            categoryIds = categoryIds.filter((i, indexId, arrayId) => {
                return indexId == arrayId.indexOf(i)
            });

            let categoriaArray = categoryIds.map((i) => {
                i = i.split('-');

                return categories.filter((m) => {
                    return m.CategoriaId == i[0].trim() && m.ProductoId == i[1].trim()
                })
            });

            tableResult = categoriaArray.map((ms) => {
                return <Table Category={ms} />
            });
        }

        if (tableResult.length > 0) {
            return (
                <div className="col-xs-12">
                    {tableResult}
                </div>
            );
        }
        else {
            return (
                <div className="col-xs-12">
                    Este perfil no tiene permisos asignados.
                </div>
            );
        }
}

export default Tables